import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import MediaControls from './component';

export default connect((state) => ({
  isEndingMeeting: get(state, ['Meeting', 'isEndingMeeting']),
  consultGuid: get(state, ['Meeting', 'chimeMeeting', 'MeetingId'], ''),
  isOnDashboard: get(state, ['Location', 'type']) === 'PRACTITIONER_DASHBOARD',
}), (dispatch) => ({
  meetingEnd: (consultGuid) => dispatch(actions.meetingEnd(consultGuid)),
}))(MediaControls);
